import { contact } from "../../models/site";
import { SmartImage } from "../SmartImage";
import { PageIntro } from "./PageIntro";

const infoSections = [
  {
    number: "01",
    eyebrow: "SERVICES & ESSENTIALS",
    title: "小星服務＆重要資訊",
    items: [
      <>小星準備了洗沐浴乳與吹風機；牙刷、牙膏和浴巾記得帶上，若需要也可以 NT$30／條租借浴巾</>,
      <>廚房歡迎大家使用，飲用水在左側水槽；食物放進冰箱前，麻煩貼上姓名與日期，才不會和其他旅人的食物搞混</>,
      <>旅途中想洗衣服，可以在 08:00–22:00 使用洗衣機，NT$50／次，自行投幣即可</>,
      <>
        想知道怎麼來小星，可以先看看<a href="/direction">交通資訊</a>；旅途中有任何問題，都歡迎透過
        <a href={contact.line} target="_blank" rel="noreferrer">LINE</a>或
        <a href={contact.instagram} target="_blank" rel="noreferrer">Instagram</a>聯繫夥伴
      </>,
    ],
  },
  {
    number: "02",
    eyebrow: "SHARED SPACE",
    title: "一起舒服地使用空間",
    items: [
      <>夜裡 22:00–08:00，讓我們一起放低音量，讓每位旅人都能好好睡一覺</>,
      <>想吃東西時，歡迎到公共區域慢慢享用；需要吸菸的朋友，麻煩移步到民宿外</>,
      <>從海邊玩水回來，可以先在庭院的「沖沙區」洗去身上的沙，再舒服地回到室內</>,
      <>離開公共空間前，麻煩一起做好垃圾分類；廚餘可以放進冷凍庫裡的集中盒</>,
    ],
  },
  {
    number: "03",
    eyebrow: "LIFE IN DULAN",
    title: "在都蘭，和日常相遇",
    items: [
      <>路上可能會遇見鄰居家熱情的大狗，牠很友善，可以放心通過</>,
      <>也常有在地貓咪居民來打招呼，平時村民已經準備了豐富伙食，不需要另外餵食牠們</>,
      <>不同季節會遇見馬陸、蚊蟲或昆蟲小訪客，讓我們一起練習與自然共處</>,
      <>若剛好遇上村莊的傳統儀式，留一點安靜的距離，就是對在地文化最溫柔的尊重</>,
      <>都蘭店家的營業時間有時和 Google Maps 不太一樣，出發前可以先打電話問問，才不會撲空</>,
    ],
  },
  {
    number: "04",
    eyebrow: "OCEAN SAFETY",
    title: "安心親近大海",
    items: [
      <>都蘭的海很美，浪也很有力量；在淺灘玩水、隨時留意海況，就能更安心地享受大海</>,
      <>岸邊有漂流木與石頭，慢慢走、留意腳步，也別忘了抬頭看看眼前的風景</>,
      <>離開前記得帶走自己的垃圾，也把珊瑚留在海邊，讓大海維持原本的樣子</>,
    ],
  },
];

export function GuestHouseInfoPage() {
  return (
    <div className="standard-page guest-info-page">
      <PageIntro
        eyebrow="GOOD TO KNOW BEFORE YOU ARRIVE"
        title="民宿資訊"
        en="GUEST HOUSE INFO"
      >
        <p>歡迎來到小星！這裡整理了一些入住資訊和生活小提醒，希望你從抵達的那一刻起，就能放鬆地享受都蘭日常。</p>
      </PageIntro>

      <section className="guest-info-overview" aria-label="入住與退房資訊">
        <SmartImage
          name="facility-front"
          alt="陽光下的都蘭小星民宿入口與庭院植物"
          eager
          sizes="(max-width: 767px) 100vw, 58vw"
        />
        <div className="guest-info-keyfacts">
          <p className="eyebrow">AT A GLANCE</p>
          <h2>讓旅程從從容容地開始</h2>
          <dl>
            <div>
              <dt>入住 Check-in</dt>
              <dd>15:00–20:00</dd>
            </div>
            <div>
              <dt>退房 Check-out</dt>
              <dd>11:00</dd>
            </div>
            <div>
              <dt>WiFi 密碼 Password</dt>
              <dd>089530132</dd>
            </div>
          </dl>
        </div>
      </section>

      <section className="guest-info-sections" aria-label="小星生活資訊">
        {infoSections.map((section) => (
          <article key={section.number} className="guest-info-section">
            <header>
              <span aria-hidden="true">{section.number}</span>
              <div>
                <p className="eyebrow">{section.eyebrow}</p>
                <h2>{section.title}</h2>
              </div>
            </header>
            <ul>
              {section.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </article>
        ))}
      </section>

      <section className="guest-info-closing">
        <SmartImage
          name="facility-rooftop"
          alt="都蘭小星觀景天台與山海景色"
          sizes="(max-width: 767px) 100vw, 50vw"
        />
        <div>
          <p className="eyebrow">SLOW DOWN & FEEL DULAN</p>
          <h2>盡情感受都蘭小日子</h2>
          <p>
            都蘭陽光溫暖、氣候宜人。小星有寬敞的公共空間，也有能看海、看星星的天台；在這裡慢下來、好好休息，再為自己充飽電。
          </p>
          <p>
            現場夥伴不定時出現，歡迎詢問行程或分享旅程。我們樂於分享在地資訊，期待與你分享這片海與陽光。
          </p>
          <div className="guest-info-actions">
            <a className="outline-dark" href="/life-in-dulan">
              探索都蘭生活
            </a>
            <a
              className="outline-dark"
              href={contact.line}
              target="_blank"
              rel="noreferrer"
            >
              LINE 聯繫我們
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
